import { render, staticRenderFns } from "./RStock.vue?vue&type=template&id=1bbac147&scoped=true"
import script from "./RStock.vue?vue&type=script&lang=js"
export * from "./RStock.vue?vue&type=script&lang=js"
import style0 from "./RStock.vue?vue&type=style&index=0&id=1bbac147&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbac147",
  null
  
)

export default component.exports